import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../Contexts/AuthContext/AuthProvider";
import SideBar from "../SideBar/SideBar";

const Header = () => {
  const { LoginWithEmail, authUser, authId, token } = useContext(AuthContext);
  const [isOpen, setIsopen] = useState(false);

  const ToggleSidebar = () => {
    isOpen === true ? setIsopen(false) : setIsopen(true);
  };

  const from = "/";
  const navigate = useNavigate();
  const [remove, setremove] = useState(false);

  const SignOut = () => {


    fetch(`https://api.wlffinance.org/api/admin/auth/logout/${authUser?._id}?deviceId=${authId?.deviceId}`, {
      method: "DELETE",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.success) {

          document.cookie = `PCX_STORE_admin_token=; expires=${new Date(
            0
          ).toUTCString()};  path=/admin`;
          document.cookie = `PCX_STORE_admin_token=; expires=${new Date(
            0
          ).toUTCString()};  path=/`;
          localStorage.removeItem("PCX_STORE_admin_ID");
          LoginWithEmail(null);
          if (authUser === null) {
            navigate(from, { replace: true });
          }
          setremove(true);

        }


      });



  };
  const logout = localStorage.getItem("PCX_STORE_admin_ID");
  useEffect(() => {
    if (!logout && remove === true) {
      navigate(from, { replace: true });
    }
  }, [remove]);

  // const [data, setData] = useState([]);

  // useEffect(() => {
  //   if (authUser?._id) {
  //     fetch(`https://api.wlffinance.org/api/admin/auth/view/${authUser?._id}?deviceId=${authId?.deviceId}`, {
  //       method: "GET",
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     })
  //       .then((res) => res.json())
  //       .then((data) => {
  //         setData(data.data);
  //       });
  //   }
  // }, [authUser]);

  const [menuSHow, setMenuShow] = useState(false);

  const handleShow = () => {
    setMenuShow(true);
  };


  useEffect(() => {

    const script = document.createElement('script');
    script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"

    const googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          autoDisplay: false,
          includedLanguages: "en,zh-CN,zh-TW",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE
        },
        "google_translate_element"
      );
    };
    document.body.appendChild(script);
    window.googleTranslateElementInit = googleTranslateElementInit;


  }, []);





  const [liveChatData, setLiveChatData] = useState(0)

  useEffect(() => {
    try {
      const interval = setInterval(() => {
        fetchLiveChatData();
      }, 2000);
      return () => clearInterval(interval);
    } catch (error) {

    }
  }, [liveChatData]);


  const fetchLiveChatData = async () => {
    try {
      fetch(`https://chat-api.wlffinance.org/api/admin/notification/view/${authUser?._id}`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            setLiveChatData(data?.PendingLiveChats);
          }

        })
        .catch((error) => {
          // console.log(error);
        });
    } catch (error) {

    }
  };


  //
  return (
    <>
      <nav className="navbar-wrapper bg--dark">
        <div className="navbar__left">
          <button className="res-sidebar-open-btn me-3" onClick={handleShow}>
            <i className="las la-bars"></i>
          </button>
          <form className="navbar-search">
            <input
              type="search"
              name="#0"
              className="navbar-search-field"
              id="searchInput"
              autoComplete="off"
              placeholder="Search here..."
            />
            <i className="las la-search"></i>
            <ul className="search-list"></ul>
          </form>
        </div>
        <div className="navbar__right">
          <ul className="navbar__action-list">
            <li className="dropdown">
              <div id="google_translate_element"></div>
            </li>
            <li className="dropdown ">
              <a
                className="primary--layer live-chat-notification-btn"
                data-bs-toggle="dropdown"
                data-display="static"
                aria-haspopup="true"
                aria-expanded="false"
                href={`https://admin-live-chat.wlffinance.org/authorized/${authUser?._id}`}
                target="_blank"
              >
                <i className="las la-bell text--primary "></i>

                {liveChatData > 99 ? "99+" : liveChatData > 0 ? <span className="live-chat-count">{liveChatData}</span> : ''}


              </a>

              {/* <div className="dropdown-menu dropdown-menu--md p-0 border-0 box--shadow1 dropdown-menu-right">
                <div className="dropdown-menu__header">
                  <span className="caption">Notification</span>
                  @if($adminNotificationCount > 0)
                            <p>@lang('You have') {{ $adminNotificationCount }} @lang('unread notification')</p>
                        @else
                            <p>@lang('No unread notification found')</p>
                        @endif
                </div>
                <div className="dropdown-menu__body">
                  <a
                    href="{{ route('admin.notification.read',$notification->id) }}"
                    className="dropdown-menu__item"
                  >
                    <div className="navbar-notifi">
                      <div className="navbar-notifi__right">
                        <h6 className="notifi__title">notification</h6>
                        <span className="time">
                          <i className="far fa-clock"></i>
                          notification time
                        </span>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="dropdown-menu__footer">
                  <a
                    href="{{ route('admin.notifications') }}"
                    className="view-all-message"
                  >
                    View all notification
                  </a>
                </div>
              </div> */}
            </li>
            {/*  */}

            <li className="dropdown">
              <button
                onClick={ToggleSidebar}
                className=""
                data-bs-toggle="dropdown"
                data-display="static"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span className="navbar-user">
                  <span className="navbar-user__thumb">
                    <img
                      src={
                        authUser?.picture
                          ? `https://api.wlffinance.org/${authUser?.picture}`
                          : ""
                      }
                      alt=""
                    />
                  </span>
                  <span className="navbar-user__info">
                    <span className="navbar-user__name">{authUser?.name}</span>
                  </span>
                  <span className="icon">
                    <i className="las la-chevron-circle-down"></i>
                  </span>
                </span>
              </button>
              <div
                className={`dropdown-menu dropdown-menu--sm p-0 border-0 box--shadow1 dropdown-menu-right ${isOpen === true ? "admin-profile-dropdown-menu" : ""
                  } `}
              >
                <Link
                  to="/admin/profile"
                  onClick={ToggleSidebar}
                  className="dropdown-menu__item d-flex align-items-center px-3 py-2"
                >
                  <i className="dropdown-menu__icon las la-user-circle"></i>
                  <span className="dropdown-menu__caption">Profile</span>
                </Link>

                <Link
                  to="/admin/password"
                  onClick={ToggleSidebar}
                  className="dropdown-menu__item d-flex align-items-center px-3 py-2"
                >
                  <i className="dropdown-menu__icon las la-key"></i>
                  <span className="dropdown-menu__caption">Password</span>
                </Link>

                <button
                  onClick={SignOut}
                  className="dropdown-menu__item d-flex align-items-center px-3 py-2"
                >
                  <i className="dropdown-menu__icon las la-sign-out-alt text-dark"></i>
                  <span className="dropdown-menu__caption">Logout</span>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </nav>

      <SideBar menuSHow={menuSHow} setMenuShow={setMenuShow} />
    </>
  );
};

export default Header;
